var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symbol symbol-40 symbol-light-primary flex-shrink-0"},[_c('span',{staticClass:"symbol-label font-size-h6 font-weight-bold"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }